/*
  Add here your own custom javascript codes
*/
document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.getElementById('toggleKitIdeal');
    const list = document.getElementById('kitIdealList');

    if(window.location.href.indexOf("products") > -1) {
    if (!toggleBtn || !list) return
    toggleBtn.addEventListener('click', function () {
      list.classList.toggle('expanded');
      if (list.classList.contains('expanded')) {
        toggleBtn.textContent = "Voir moins";
      } else {
        toggleBtn.textContent = "Voir plus";
      }
  });
  }
});

// Product page: move kit manuals/guides above "Contenu du kit" on mobile without duplicating markup
(function () {
  const MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 1199px)') : null

  function placeKitManualsGuides () {
    const sections = document.querySelectorAll('.kit-manuals-guides--responsive')
    sections.forEach(function (section) {
      if (!(section instanceof HTMLElement)) return

      const root = section.closest('.product-main')
      if (!(root instanceof HTMLElement)) return

      const anchor = root.querySelector('.kit-manuals-guides-anchor')
      const mobileTarget = root.querySelector('.kit-manuals-guides-mobile-target')
      if (!(anchor instanceof HTMLElement) || !(mobileTarget instanceof HTMLElement)) return

      if (MOBILE_MQ && MOBILE_MQ.matches) {
        if (section.parentElement !== mobileTarget) {
          mobileTarget.appendChild(section)
        }
        return
      }

      if (section.previousElementSibling !== anchor || section.parentElement !== anchor.parentElement) {
        anchor.insertAdjacentElement('afterend', section)
      }
    })
  }

  placeKitManualsGuides()
  document.addEventListener('DOMContentLoaded', placeKitManualsGuides)
  window.addEventListener('load', placeKitManualsGuides, { passive: true })
  window.addEventListener('resize', placeKitManualsGuides, { passive: true })
  document.addEventListener('shopify:section:load', function () {
    placeKitManualsGuides()
  })
})();

// Shopify Forms teaser: reduce the initial mobile preview size inside the app shadow DOM
(function () {
  const MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null
  const STYLE_ATTR = 'data-mds-shopify-forms-mobile-teaser'
  const CONTAINER_SELECTOR = [
    '#app-embed',
    '[id*="app-embed"]',
    '[id*="shopify-block"][id*="forms"]',
    '[class*="shopify-form"]',
    'shopify-forms'
  ].join(', ')
  const CSS_TEXT = [
    '@media (max-width: 767.98px) {',
    '  [class*="teaser"],',
    '  [class*="Teaser"],',
    '  button[aria-expanded],',
    '  [role="button"][aria-expanded] {',
    '    max-width: min(240px, calc(100vw - 1.5rem)) !important;',
    '    min-height: 0 !important;',
    '    padding: 0.625rem 0.875rem !important;',
    '    font-size: 0.875rem !important;',
    '    line-height: 1.25 !important;',
    '    gap: 0.5rem !important;',
    '    white-space: normal !important;',
    '  }',
    '  button[aria-expanded] *,',
    '  [role="button"][aria-expanded] * {',
    '    font-size: inherit !important;',
    '    line-height: inherit !important;',
    '  }',
    '  button[aria-expanded] p,',
    '  [role="button"][aria-expanded] p {',
    '    margin: 0 !important;',
    '  }',
    '  button[aria-expanded] img,',
    '  button[aria-expanded] svg,',
    '  [role="button"][aria-expanded] img,',
    '  [role="button"][aria-expanded] svg {',
    '    width: 1rem !important;',
    '    height: 1rem !important;',
    '    max-width: 1rem !important;',
    '    max-height: 1rem !important;',
    '    flex: 0 0 1rem !important;',
    '  }',
    '}'
  ].join('\n')

  function isMobileViewport () {
    return !MOBILE_MQ || MOBILE_MQ.matches
  }

  function elementLooksLikeFormsHost (el) {
    if (!(el instanceof Element)) return false

    const tagName = (el.tagName || '').toLowerCase()
    const id = (el.id || '').toLowerCase()
    const className = typeof el.className === 'string' ? el.className.toLowerCase() : ''

    if (tagName === 'shopify-forms') return true
    if (tagName.includes('shopify') && tagName.includes('form')) return true
    if (id.includes('forms') || id.includes('app-embed')) return true
    if (className.includes('shopify-form') || className.includes('shopify forms')) return true

    return !!el.closest(CONTAINER_SELECTOR)
  }

  function injectStyles (shadowRoot) {
    if (!(shadowRoot instanceof ShadowRoot)) return
    if (shadowRoot.querySelector('style[' + STYLE_ATTR + ']')) return

    const style = document.createElement('style')
    style.setAttribute(STYLE_ATTR, 'true')
    style.textContent = CSS_TEXT
    shadowRoot.appendChild(style)
  }

  function collectHosts (root) {
    const hosts = new Set()
    const scope = root && root.querySelectorAll ? root : document

    scope.querySelectorAll(CONTAINER_SELECTOR).forEach(function (container) {
      if (container.shadowRoot) hosts.add(container)
      container.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) hosts.add(el)
      })
    })

    if (hosts.size > 0) return hosts

    scope.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot && elementLooksLikeFormsHost(el)) {
        hosts.add(el)
      }
    })

    return hosts
  }

  function run (root) {
    if (!isMobileViewport()) return

    collectHosts(root).forEach(function (host) {
      injectStyles(host.shadowRoot)
    })
  }

  let rafId = 0
  function schedule (root) {
    if (rafId) window.cancelAnimationFrame(rafId)
    rafId = window.requestAnimationFrame(function () {
      rafId = 0
      run(root)
    })
  }

  schedule(document)
  document.addEventListener('DOMContentLoaded', function () { schedule(document) })
  window.addEventListener('load', function () { schedule(document) }, { passive: true })
  document.addEventListener('shopify:section:load', function (e) {
    schedule(e && e.target ? e.target : document)
  })

  if (MOBILE_MQ) {
    const onViewportChange = function () { schedule(document) }
    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', onViewportChange)
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(onViewportChange)
    }
  }

  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue
          schedule(node)
          return
        }
      }
    })

    observer.observe(document.documentElement, { childList: true, subtree: true })
  }
})();

// Article page (mobile): horizontal scroll only on tables via dedicated wrappers
(function () {
  const PAGE_CLASS = 'page-type-article'
  const TABLE_SELECTOR = '.article-main .article-content.rte table'
  const WRAPPER_CLASS = 'article-table-scroll'

  function wrapTable (table) {
    if (!(table instanceof HTMLTableElement)) return
    const parent = table.parentElement
    if (!parent || parent.classList.contains(WRAPPER_CLASS)) return

    const wrapper = document.createElement('div')
    wrapper.className = WRAPPER_CLASS
    parent.insertBefore(wrapper, table)
    wrapper.appendChild(table)
  }

  function initTableScroll (root) {
    if (!document.body || !document.body.classList.contains(PAGE_CLASS)) return
    const scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll(TABLE_SELECTOR).forEach(wrapTable)
  }

  initTableScroll(document)

  document.addEventListener('DOMContentLoaded', function () {
    initTableScroll(document)
  })

  window.addEventListener('load', function () {
    initTableScroll(document)
  }, { passive: true })

  document.addEventListener('shopify:section:load', function (e) {
    initTableScroll(e && e.target ? e.target : document)
  })
})();

// Smooth scroll to FAQ with dynamic offset for sticky header
(function () {
  function getTopOverlayHeight () {
    let total = 0
    // Primary sticky header
    const header = document.getElementById('header-group')
    if (header) {
      const cs = window.getComputedStyle(header)
      const stickyActive = cs && (cs.position === 'sticky' || cs.position === 'fixed')
      if (stickyActive) total += header.offsetHeight || 0
    }
    // Shopify preview/admin bars (when present)
    const previewBar = document.getElementById('preview-bar-iframe') || document.getElementById('shopify-preview-bar-iframe')
    if (previewBar) total += (previewBar.getBoundingClientRect().height || previewBar.offsetHeight || 0)
    // Optional announcement bars used by many themes
    const announce = document.getElementById('shopify-section-announcement') || document.getElementById('announcement-bar')
    if (announce) {
      const csA = window.getComputedStyle(announce)
      const stickyA = csA && (csA.position === 'sticky' || csA.position === 'fixed')
      if (stickyA) total += announce.offsetHeight || 0
    }
    return total
  }

  function scrollToFaqAnchor (updateHash) {
    const target = document.getElementById('collection-faq')
    if (!target) return

    const overlayOnly = getTopOverlayHeight()
    const extra = overlayOnly > 0 ? 8 : 0 // add breathing space only when something overlays
    const overlay = overlayOnly + extra
    // Use CSS scroll-margin for one smooth, jitter-free scroll
    target.style.scrollMarginTop = overlay + 'px'
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })

    if (updateHash && history && history.pushState) {
      history.pushState(null, '', '#collection-faq')
    }
  }

  // Intercept clicks on any link to #collection-faq
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="#collection-faq"]')
    if (!link) return
    const target = document.getElementById('collection-faq')
    if (target) {
      e.preventDefault()
      // reflect destination and align perfectly using dynamic scroll-margin
      scrollToFaqAnchor(true)
    }
    // if no target exists on page, let browser follow the hash normally
  })

  // If page loads with #collection-faq in URL, adjust after load
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash === '#collection-faq') {
      // Wait a tick for layout to settle
      setTimeout(function(){ scrollToFaqAnchor(false) }, 50)
    }
  })

  // Also adjust if hash changes to #collection-faq later
  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#collection-faq') {
      setTimeout(function(){ scrollToFaqAnchor(false) }, 0)
    }
  })
})();

// Collection/search product cards: on mobile/touch, do not trap the first tap on the image.
// The image link should always navigate immediately.
(function () {
  const CARD_SELECTOR = '.page-type-collection .product-card--interactive-highlights, .page-type-search .product-card--interactive-highlights'
  const MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 991.98px), (hover: none)') : null
  const OPEN_CLASS = 'is-highlights-open'

  function isMobileTouchMode () {
    return !MOBILE_MQ || MOBILE_MQ.matches
  }

  function closeAllHighlights (exceptCard) {
    document.querySelectorAll(CARD_SELECTOR + '.' + OPEN_CLASS).forEach(function (card) {
      if (exceptCard && card === exceptCard) return
      card.classList.remove(OPEN_CLASS)
    })
  }

  document.addEventListener('click', function (event) {
    if (!isMobileTouchMode()) {
      closeAllHighlights()
      return
    }

    const target = event.target instanceof Element ? event.target : null
    if (!target) return

    const card = target.closest(CARD_SELECTOR)

    if (!card) {
      closeAllHighlights()
    }
  })

  window.addEventListener('resize', function () {
    if (!isMobileTouchMode()) closeAllHighlights()
  }, { passive: true })

  document.addEventListener('shopify:section:load', function () {
    if (!isMobileTouchMode()) closeAllHighlights()
  })
})();

// Product card titles: fallback for browsers without line-clamp support
(function () {
  if (window.CSS && (CSS.supports('-webkit-line-clamp', '3') || CSS.supports('line-clamp', '3'))) {
    return
  }

  const TITLE_SELECTOR = '.product-card-title'
  const MAX_ITERATIONS = 18
  const MIN_FONT_SIZE_PX = 6
  const OBSERVED_FLAG = 'mdsTitleObserved'

  function getLineHeightPx (computedStyle, fontSizePx) {
    const raw = computedStyle.lineHeight
    if (raw === 'normal') return fontSizePx * 1.2

    const parsed = parseFloat(raw)
    if (!Number.isFinite(parsed) || parsed <= 0) return fontSizePx * 1.2

    // Some browsers may return a unitless number (e.g. "1.4") for line-height.
    if (raw.endsWith('px')) return parsed
    if (raw.endsWith('%')) return (parsed / 100) * fontSizePx
    return parsed * fontSizePx
  }

  function isMoreThanThreeLines (el) {
    const computed = window.getComputedStyle(el)
    const fontSize = parseFloat(computed.fontSize)
    if (!Number.isFinite(fontSize) || fontSize <= 0) return false

    const lineHeight = getLineHeightPx(computed, fontSize)
    if (!Number.isFinite(lineHeight) || lineHeight <= 0) return false

    const paddingTop = parseFloat(computed.paddingTop) || 0
    const paddingBottom = parseFloat(computed.paddingBottom) || 0
    const contentHeight = el.scrollHeight - paddingTop - paddingBottom
    return contentHeight > (lineHeight * 3 + 0.5)
  }

  function fitTitle (el) {
    if (!(el instanceof HTMLElement)) return

    el.style.removeProperty('font-size')
    el.style.maxHeight = ''
    el.style.overflow = ''

    const computed = window.getComputedStyle(el)
    const baseSize = parseFloat(computed.fontSize)
    if (!Number.isFinite(baseSize) || baseSize <= 0) return

    if (!isMoreThanThreeLines(el)) return

    let low = MIN_FONT_SIZE_PX
    let high = baseSize
    let best = null

    for (let i = 0; i < MAX_ITERATIONS; i++) {
      const mid = (low + high) / 2
      // Override Bootstrap utilities like `.fs-*` which use `!important`.
      el.style.setProperty('font-size', mid + 'px', 'important')

      if (isMoreThanThreeLines(el)) {
        high = mid
      } else {
        best = mid
        low = mid
      }
    }

    if (best == null) {
      el.style.setProperty('font-size', MIN_FONT_SIZE_PX + 'px', 'important')
    } else {
      el.style.setProperty('font-size', best + 'px', 'important')
    }
  }

  function fitAll (root) {
    const scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll(TITLE_SELECTOR).forEach(fitTitle)
  }

  let rafId = 0
  let isFitting = false
  const resizeObserver = window.ResizeObserver
    ? new ResizeObserver(function () { scheduleFit() })
    : null

  function observeTitles (root) {
    if (!resizeObserver) return
    const scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll(TITLE_SELECTOR).forEach(function (el) {
      if (!(el instanceof Element)) return
      if (el.dataset && el.dataset[OBSERVED_FLAG]) return
      if (el.dataset) el.dataset[OBSERVED_FLAG] = '1'
      resizeObserver.observe(el)
    })
  }

  function scheduleFit () {
    if (isFitting) return
    if (rafId) cancelAnimationFrame(rafId)
    rafId = requestAnimationFrame(function () {
      isFitting = true
      try { fitAll(document) } finally { isFitting = false }
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    isFitting = true
    try { fitAll(document) } finally { isFitting = false }
    observeTitles(document)
    // Run a second time after images/fonts/layout settle (swipers, etc.)
    setTimeout(function () { isFitting = true; try { fitAll(document) } finally { isFitting = false } }, 250)
    setTimeout(function () { isFitting = true; try { fitAll(document) } finally { isFitting = false } }, 1000)

    // Some components (swiper, filters) update widths after init; retry briefly.
    let tries = 0
    const settleId = setInterval(function () {
      tries++
      scheduleFit()
      if (tries >= 10) clearInterval(settleId)
    }, 200)
  })

  window.addEventListener('resize', scheduleFit, { passive: true })
  document.addEventListener('shopify:section:load', scheduleFit)
  window.addEventListener('load', scheduleFit, { passive: true })

  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(scheduleFit).catch(function () {})
  }

  // Catch product cards injected dynamically (recommendations, filters, etc.)
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue
        if (node.matches(TITLE_SELECTOR) || node.querySelector(TITLE_SELECTOR)) {
          observeTitles(node)
          scheduleFit()
          return
        }
      }
    }
  })
  observer.observe(document.documentElement, { childList: true, subtree: true })

  // Manual trigger for debugging in console: `window.MDSFitProductCardTitles()`
  window.MDSFitProductCardTitles = function () {
    isFitting = true
    try { fitAll(document) } finally { isFitting = false }
  }

  // Quick report for debugging in console: `window.MDSProductCardTitleReport()`
  window.MDSProductCardTitleReport = function () {
    return Array.from(document.querySelectorAll(TITLE_SELECTOR)).slice(0, 10).map(function (el) {
      const cs = window.getComputedStyle(el)
      const fontSize = cs.fontSize
      const lineHeight = cs.lineHeight
      const styleAttr = el.getAttribute('style') || ''
      const paddingTop = parseFloat(cs.paddingTop) || 0
      const paddingBottom = parseFloat(cs.paddingBottom) || 0
      const contentHeight = el.scrollHeight - paddingTop - paddingBottom
      const lineHeightPx = getLineHeightPx(cs, parseFloat(cs.fontSize) || 0)
      const approxLines = lineHeightPx > 0 ? (contentHeight / lineHeightPx) : null
      return {
        text: (el.textContent || '').trim().slice(0, 80),
        fontSize,
        lineHeight,
        approxLines,
        scrollHeight: el.scrollHeight,
        clientHeight: el.clientHeight,
        styleAttr
      }
    })
  }
})();

// Product page: smoother tab switch (animate to exact height instead of large max-height)
(function () {
  const CONTAINER_SELECTOR = '[data-product-tabs]'
  const RADIO_SELECTOR = '.product-tabs__radio'
  const TAB_SELECTOR = '.product-tabs__tab'
  const PANEL_SELECTOR = '.product-tabs__panel'
  const DESKTOP_MQ = window.matchMedia ? window.matchMedia('(min-width: 769px)') : null
  const REDUCED_MOTION_MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null
  const OPEN_PANEL_EXTRA_PX = 24
  const MOBILE_SCROLL_DELAY_MS = 460
  const MOBILE_SCROLL_EXTRA_OFFSET_PX = 16
  const mobileScrollTimers = new WeakMap()

  function isDesktop () {
    return !DESKTOP_MQ || DESKTOP_MQ.matches
  }

  function prefersReducedMotion () {
    return !!(REDUCED_MOTION_MQ && REDUCED_MOTION_MQ.matches)
  }

  function getTopOverlayHeight () {
    let total = 0

    const header = document.getElementById('header-group')
    if (header) {
      const headerStyle = window.getComputedStyle(header)
      const headerIsSticky = headerStyle && (headerStyle.position === 'sticky' || headerStyle.position === 'fixed')
      if (headerIsSticky) total += header.offsetHeight || 0
    }

    const previewBar = document.getElementById('preview-bar-iframe') || document.getElementById('shopify-preview-bar-iframe')
    if (previewBar) total += (previewBar.getBoundingClientRect().height || previewBar.offsetHeight || 0)

    const announcement = document.getElementById('shopify-section-announcement') || document.getElementById('announcement-bar')
    if (announcement) {
      const announcementStyle = window.getComputedStyle(announcement)
      const announcementIsSticky = announcementStyle && (announcementStyle.position === 'sticky' || announcementStyle.position === 'fixed')
      if (announcementIsSticky) total += announcement.offsetHeight || 0
    }

    return total
  }

  function scrollHeadingToTop (heading, smooth) {
    if (!(heading instanceof Element)) return
    const currentTop = window.pageYOffset || document.documentElement.scrollTop || 0
    const headingTop = heading.getBoundingClientRect().top + window.pageYOffset
    const desiredTop = Math.max(0, headingTop - getTopOverlayHeight() - MOBILE_SCROLL_EXTRA_OFFSET_PX)
    // Mobile UX rule: never scroll down on tab tap.
    const targetTop = Math.min(currentTop, desiredTop)
    window.scrollTo({
      top: targetTop,
      behavior: smooth && !prefersReducedMotion() ? 'smooth' : 'auto',
    })
  }

  function getDescriptionHeading (container) {
    if (!(container instanceof Element)) return null
    const descriptionRadio = container.querySelector(RADIO_SELECTOR + '[id$="-description"]')
    if (!(descriptionRadio instanceof Element)) return null
    const descriptionHeading = descriptionRadio.nextElementSibling
    return descriptionHeading instanceof Element ? descriptionHeading : null
  }

  function maybeScrollMobileToTabHeading (container, radio, immediate) {
    if (!(container instanceof Element)) return
    if (!(radio instanceof Element)) return
    if (isDesktop()) return

    const clickedHeading = radio.nextElementSibling
    const heading = getDescriptionHeading(container) || (clickedHeading instanceof Element ? clickedHeading : null)
    if (!(heading instanceof Element)) return

    if (immediate) {
      // Move before accordion layout changes to avoid "down then up" visual jump.
      scrollHeadingToTop(heading, false)
    }

    const existingTimer = mobileScrollTimers.get(container)
    if (existingTimer) window.clearTimeout(existingTimer)

    // Final pass: once accordion transition settled, lock exact alignment.
    const timerId = window.setTimeout(function () {
      if (typeof radio.blur === 'function') radio.blur()
      scrollHeadingToTop(heading, false)
      mobileScrollTimers.delete(container)
    }, MOBILE_SCROLL_DELAY_MS)

    mobileScrollTimers.set(container, timerId)
  }

  function isPanelOpen (panel) {
    if (!(panel instanceof Element)) return false
    const tabNode = panel.previousElementSibling
    const radio = tabNode && tabNode.previousElementSibling
    return !!(radio && radio.matches && radio.matches(RADIO_SELECTOR) && radio.checked)
  }

  function getOpenPanelMaxHeight (panel) {
    if (!(panel instanceof HTMLElement)) return '0px'
    return Math.ceil(panel.scrollHeight + OPEN_PANEL_EXTRA_PX) + 'px'
  }

  function getPanelForRadio (radio) {
    if (!(radio instanceof Element)) return null

    const tabNode = radio.nextElementSibling
    if (!tabNode) return null

    const isLegacyLabel = tabNode.classList && tabNode.classList.contains('product-tabs__tab')
    const isHeadingWrapper = tabNode.classList && tabNode.classList.contains('product-tabs__heading')
    if (!isLegacyLabel && !isHeadingWrapper) return null

    const panel = tabNode.nextElementSibling
    if (panel && panel.classList && panel.classList.contains('product-tabs__panel')) return panel
    return null
  }

  function clearInlineMaxHeights (container) {
    container.querySelectorAll(PANEL_SELECTOR).forEach(function (panel) {
      if (!(panel instanceof HTMLElement)) return
      panel.style.maxHeight = ''
    })
  }

  function updatePanelHeights (container) {
    if (!(container instanceof Element)) return

    if (!isDesktop()) {
      clearInlineMaxHeights(container)
      return
    }

    const checked = container.querySelector(RADIO_SELECTOR + ':checked')
    const openPanel = getPanelForRadio(checked)

    container.querySelectorAll(PANEL_SELECTOR).forEach(function (panel) {
      if (!(panel instanceof HTMLElement)) return

      if (panel === openPanel) {
        // Keep a fixed pixel max-height (+safety buffer) to avoid end-of-transition snap and clipping.
        panel.style.maxHeight = getOpenPanelMaxHeight(panel)
        return
      }

      // Ensure we animate from current height when closing.
      if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
        panel.style.maxHeight = panel.scrollHeight + 'px'
        // Force reflow so the next assignment transitions.
        void panel.offsetHeight
      }
      panel.style.maxHeight = '0px'
    })
  }

  function initContainer (container) {
    if (!(container instanceof Element)) return
    if (container.dataset && container.dataset.mdsTabsSmoothInit === '1') return
    if (container.dataset) container.dataset.mdsTabsSmoothInit = '1'

    container.querySelectorAll(PANEL_SELECTOR).forEach(function (panel) {
      if (!(panel instanceof HTMLElement)) return
      if (panel.dataset && panel.dataset.mdsTabsAutoHeightInit === '1') return
      if (panel.dataset) panel.dataset.mdsTabsAutoHeightInit = '1'

      panel.addEventListener('transitionend', function (e) {
        if (!isDesktop()) return
        if (!e || e.propertyName !== 'max-height') return
        if (!isPanelOpen(panel)) return
        panel.style.maxHeight = getOpenPanelMaxHeight(panel)
      })
    })

    container.addEventListener('change', function (e) {
      const target = e.target
      if (!(target instanceof Element)) return
      if (!target.matches(RADIO_SELECTOR)) return
      updatePanelHeights(container)
      maybeScrollMobileToTabHeading(container, target, false)
    })

    // Mobile: prevent native label->radio focus scrolling, then switch tab manually.
    container.addEventListener('click', function (e) {
      if (isDesktop()) return
      const trigger = e.target && e.target.closest ? e.target.closest(TAB_SELECTOR + ', .product-tabs__heading') : null
      if (!(trigger instanceof Element)) return

      const label = trigger.matches(TAB_SELECTOR) ? trigger : trigger.querySelector(TAB_SELECTOR)
      if (!(label instanceof Element)) return

      const radioId = label.getAttribute('for')
      if (!radioId) return

      const radio = document.getElementById(radioId)
      if (!(radio instanceof HTMLInputElement) || !radio.matches(RADIO_SELECTOR)) return

      e.preventDefault()
      maybeScrollMobileToTabHeading(container, radio, true)

      if (radio.checked) {
        return
      }

      radio.checked = true
      radio.dispatchEvent(new Event('change', { bubbles: true }))
    })

    // First paint + after layout settles (images, fonts, etc.)
    updatePanelHeights(container)
    setTimeout(function () { updatePanelHeights(container) }, 250)
    setTimeout(function () { updatePanelHeights(container) }, 1000)
  }

  function initAll (root) {
    const scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll(CONTAINER_SELECTOR).forEach(initContainer)
  }

  function updateAll () {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(function (container) {
      updatePanelHeights(container)
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document)
    updateAll()
  })

  window.addEventListener('load', function () {
    initAll(document)
    updateAll()
  }, { passive: true })

  window.addEventListener('resize', function () {
    updateAll()
  }, { passive: true })

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e && e.target ? e.target : document)
    updateAll()
  })

  if (DESKTOP_MQ) {
    const onMqChange = function () { updateAll() }
    if (typeof DESKTOP_MQ.addEventListener === 'function') DESKTOP_MQ.addEventListener('change', onMqChange)
    else if (typeof DESKTOP_MQ.addListener === 'function') DESKTOP_MQ.addListener(onMqChange)
  }
})();

// Judge.me: add a small "verified" badge next to the bottom widget review count text (e.g. "4 avis")
(function () {
  // Disabled: now handled via CSS in `assets/product.css` (works with revamped `jm-*` widget markup).
  return
  const WIDGET_ID = 'judgeme_product_reviews'
  const BADGE_CLASS = 'mds-jdgm-verified-badge'

  function ensureBadge (container) {
    if (!(container instanceof Element)) return false
    if (container.querySelector('.' + BADGE_CLASS)) return true

    const badge = document.createElement('span')
    badge.className = BADGE_CLASS
    badge.setAttribute('aria-hidden', 'true')
    badge.textContent = '✓'
    container.appendChild(badge)
    return true
  }

  function findLegacyCountEl (widget) {
    const selectors = [
      '.jdgm-rev-widg__summary-text',
      '.jdgm-widget__summary-text',
      '.jdgm-rev-widg__summary',
      '.jdgm-widget__summary',
    ]
    for (const selector of selectors) {
      const el = widget.querySelector(selector)
      if (el) return el
    }
    return null
  }

  function findRevampedCountEl (widget) {
    const root = widget.querySelector('[data-widget-container="review-widget"]') || widget.querySelector('.jm-review-widget')
    if (!root) return null

    const candidates = root.querySelectorAll('.jm-average-rating-display .jm-text, .jm-review-widget__header .jm-text')
    for (const el of candidates) {
      if (!(el instanceof Element)) continue
      const text = (el.textContent || '').trim()
      if (!text) continue
      if (!/\d/.test(text)) continue
      if (!/\b(avis|review|reviews)\b/i.test(text)) continue
      return el
    }
    return null
  }

  function addBadgeIfNeeded () {
    const widget =
      document.getElementById(WIDGET_ID) ||
      document.querySelector('[data-widget-container="review-widget"]') ||
      document.querySelector('.jm-review-widget')
    if (!widget) return

    const countEl = findRevampedCountEl(widget) || findLegacyCountEl(widget)
    if (!countEl) return

    // Avoid duplicating if Judge.me rerenders.
    if (countEl.querySelector('.' + BADGE_CLASS)) return
    ensureBadge(countEl)
  }

  function init () {
    addBadgeIfNeeded()

    const widget = document.getElementById(WIDGET_ID)
    if (!window.MutationObserver) return

    let raf = 0
    const schedule = function () {
      if (raf) return
      raf = requestAnimationFrame(function () {
        raf = 0
        addBadgeIfNeeded()
      })
    }

    if (widget) {
      const mo = new MutationObserver(schedule)
      mo.observe(widget, { childList: true, subtree: true })
    }

    // Fallback: if Judge.me mounts outside/replaces the wrapper, still try.
    const docMo = new MutationObserver(schedule)
    docMo.observe(document.documentElement, { childList: true, subtree: true })
  }

  document.addEventListener('DOMContentLoaded', init)
  window.addEventListener('load', init, { passive: true })
})();

// Judge.me: rating histogram + click-to-filter (revamped `jm-*` widget + legacy fallback)
(function () {
  const WRAPPER_ID = 'judgeme_product_reviews'
  const HIST_ATTR = 'data-mds-jm-rating-histogram'
  const HIDDEN_CLASS = 'mds-jm-review-hidden'
  const ACTIVE_CLASS = 'is-active'
  const STAR_FULL = '\u2605'
  const STAR_EMPTY = '\u2606'

  function getWrapperEl () {
    return document.getElementById(WRAPPER_ID)
  }

  function findWidgetRoot (wrapper) {
    if (!wrapper) return null
    return (
      wrapper.querySelector('.jm-review-widget') ||
      wrapper.querySelector('[data-widget-container="review-widget"]') ||
      wrapper.querySelector('.jdgm-review-widget') ||
      null
    )
  }

  function getProductId (wrapper) {
    if (!wrapper) return null
    const raw = wrapper.getAttribute('data-product-id') || wrapper.getAttribute('data-id')
    if (!raw) return null
    const num = parseInt(String(raw), 10)
    return Number.isFinite(num) ? String(num) : null
  }

  function normalizeCounts (counts) {
    const out = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
    if (!counts) return out
    for (let i = 1; i <= 5; i++) {
      const val = counts[i] ?? counts[String(i)]
      const n = parseInt(String(val ?? 0), 10)
      out[i] = Number.isFinite(n) ? n : 0
    }
    return out
  }

  function getCountsFromJdgmData (productId) {
    try {
      const jdgm = window.jdgm
      if (!productId || !jdgm || !jdgm.data || !jdgm.data.reviewWidget) return null
      const data = jdgm.data.reviewWidget[productId] || jdgm.data.reviewWidget[String(productId)]
      if (!data) return null

      const candidate =
        data.rating_distribution ||
        data.ratingDistribution ||
        data.rating_counts ||
        data.ratingCounts ||
        data.ratings_count ||
        data.ratingsCount ||
        data.distribution ||
        null

      if (Array.isArray(candidate) && candidate.length >= 5) {
        return normalizeCounts({
          1: candidate[0],
          2: candidate[1],
          3: candidate[2],
          4: candidate[3],
          5: candidate[4],
        })
      }

      if (candidate && typeof candidate === 'object') {
        return normalizeCounts(candidate)
      }

      return null
    } catch (e) {
      return null
    }
  }

  function parseRatingFromAriaLabel (label) {
    if (!label) return null
    const m = String(label).match(/(\d)\s*(?:\/|out of)\s*5/i)
    if (!m) return null
    const n = parseInt(m[1], 10)
    return n >= 1 && n <= 5 ? n : null
  }

  function getCountsFromDom (widgetRoot) {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
    if (!widgetRoot) return counts

    widgetRoot.querySelectorAll('.jm-review-item').forEach(function (item) {
      if (!(item instanceof Element)) return
      const star = item.querySelector('.jm-star-rating[aria-label]')
      const rating = star ? parseRatingFromAriaLabel(star.getAttribute('aria-label')) : null
      if (rating) counts[rating]++
    })

    widgetRoot.querySelectorAll('.jdgm-rev').forEach(function (item) {
      if (!(item instanceof Element)) return
      const scoreEl = item.querySelector('[data-score]')
      const scoreRaw = scoreEl ? scoreEl.getAttribute('data-score') : null
      const score = scoreRaw ? parseInt(String(scoreRaw), 10) : null
      if (score && score >= 1 && score <= 5) counts[score]++
    })

    return counts
  }

  function ensureHistogramContainer (widgetRoot) {
    if (!widgetRoot) return null

    const header =
      widgetRoot.querySelector('.jm-review-widget__header') ||
      widgetRoot.querySelector('.jm-review-widget-minimal-header') ||
      widgetRoot.querySelector('.jdgm-rev-widg__header') ||
      widgetRoot

    if (!header) return null

    const existing = header.querySelector('[' + HIST_ATTR + ']')
    if (existing) return existing

    const container = document.createElement('div')
    container.setAttribute(HIST_ATTR, '')
    container.className = 'mds-jm-rating-histogram'
    header.appendChild(container)
    return container
  }

  function renderHistogramSkeleton (container) {
    if (!container) return
    if (container.dataset && container.dataset.mdsRendered === '1') return
    if (container.dataset) container.dataset.mdsRendered = '1'

    container.innerHTML = ''

    for (let rating = 5; rating >= 1; rating--) {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'mds-jm-rating-histogram__row'
      btn.dataset.rating = String(rating)
      btn.setAttribute('aria-pressed', 'false')

      const stars = document.createElement('span')
      stars.className = 'mds-jm-rating-histogram__stars'
      stars.setAttribute('aria-hidden', 'true')
      let starsText = ''
      for (let i = 1; i <= 5; i++) starsText += i <= rating ? STAR_FULL : STAR_EMPTY
      stars.textContent = starsText

      const bar = document.createElement('span')
      bar.className = 'mds-jm-rating-histogram__bar'
      const fill = document.createElement('span')
      fill.className = 'mds-jm-rating-histogram__fill'
      bar.appendChild(fill)

      const count = document.createElement('span')
      count.className = 'mds-jm-rating-histogram__count'
      count.textContent = '0'

      btn.appendChild(stars)
      btn.appendChild(bar)
      btn.appendChild(count)

      container.appendChild(btn)
    }
  }

  function updateHistogram (container, counts) {
    if (!container) return

    const c = normalizeCounts(counts)
    const max = Math.max(c[1], c[2], c[3], c[4], c[5], 0)

    container.querySelectorAll('.mds-jm-rating-histogram__row').forEach(function (row) {
      if (!(row instanceof HTMLElement)) return
      const rating = parseInt(row.dataset.rating || '', 10)
      if (!rating || rating < 1 || rating > 5) return

      const n = c[rating] || 0
      const pct = max > 0 ? Math.round((n / max) * 100) : 0

      row.style.setProperty('--mds-fill', pct + '%')
      const countEl = row.querySelector('.mds-jm-rating-histogram__count')
      if (countEl) countEl.textContent = String(n)
    })
  }

  function setActiveRow (container, ratingOrNull) {
    if (!container) return
    container.querySelectorAll('.mds-jm-rating-histogram__row').forEach(function (row) {
      if (!(row instanceof HTMLElement)) return
      const r = parseInt(row.dataset.rating || '', 10)
      const active = ratingOrNull != null && r === ratingOrNull
      row.classList.toggle(ACTIVE_CLASS, active)
      row.setAttribute('aria-pressed', active ? 'true' : 'false')
    })
  }

  function applyFilter (widgetRoot, ratingOrNull) {
    if (!widgetRoot) return

    widgetRoot.querySelectorAll('.jm-review-item').forEach(function (item) {
      if (!(item instanceof HTMLElement)) return
      if (ratingOrNull == null) {
        item.classList.remove(HIDDEN_CLASS)
        return
      }
      const star = item.querySelector('.jm-star-rating[aria-label]')
      const rating = star ? parseRatingFromAriaLabel(star.getAttribute('aria-label')) : null
      item.classList.toggle(HIDDEN_CLASS, rating !== ratingOrNull)
    })

    widgetRoot.querySelectorAll('.jdgm-rev').forEach(function (item) {
      if (!(item instanceof HTMLElement)) return
      if (ratingOrNull == null) {
        item.classList.remove(HIDDEN_CLASS)
        return
      }
      const scoreEl = item.querySelector('[data-score]')
      const scoreRaw = scoreEl ? scoreEl.getAttribute('data-score') : null
      const score = scoreRaw ? parseInt(String(scoreRaw), 10) : null
      item.classList.toggle(HIDDEN_CLASS, score !== ratingOrNull)
    })
  }

  function initHistogram (wrapper, widgetRoot) {
    if (!wrapper || !widgetRoot) return

    let currentRoot = widgetRoot
    let currentContainer = ensureHistogramContainer(currentRoot)
    if (!currentContainer) return

    function removeDuplicateHistograms () {
      wrapper.querySelectorAll('[' + HIST_ATTR + ']').forEach(function (el) {
        if (el !== currentContainer) el.remove()
      })
    }

    renderHistogramSkeleton(currentContainer)
    removeDuplicateHistograms()

    const productId = getProductId(wrapper)
    let selectedRating = null

    const refresh = function () {
      const counts = getCountsFromJdgmData(productId) || getCountsFromDom(currentRoot)
      updateHistogram(currentContainer, counts)
      setActiveRow(currentContainer, selectedRating)
      applyFilter(currentRoot, selectedRating)
    }

    if (!wrapper.dataset || wrapper.dataset.mdsJmHistogramClickInit !== '1') {
      if (wrapper.dataset) wrapper.dataset.mdsJmHistogramClickInit = '1'
      wrapper.addEventListener('click', function (e) {
        const btn = e.target && e.target.closest ? e.target.closest('.mds-jm-rating-histogram__row') : null
        if (!btn || !(btn instanceof HTMLElement)) return
        if (!btn.closest('[' + HIST_ATTR + ']')) return
        const rating = parseInt(btn.dataset.rating || '', 10)
        if (!rating || rating < 1 || rating > 5) return

        selectedRating = selectedRating === rating ? null : rating
        refresh()
      })
    }

    refresh()

    if (window.MutationObserver) {
      let raf = 0
      const schedule = function () {
        if (raf) return
        raf = requestAnimationFrame(function () {
          raf = 0
          const nextRoot = findWidgetRoot(wrapper)
          if (!nextRoot) return
          currentRoot = nextRoot
          const nextContainer = ensureHistogramContainer(currentRoot)
          if (!nextContainer) return
          currentContainer = nextContainer
          renderHistogramSkeleton(currentContainer)
          removeDuplicateHistograms()
          refresh()
        })
      }
      const mo = new MutationObserver(schedule)
      mo.observe(wrapper, { childList: true, subtree: true })
    }
  }

  function boot () {
    const wrapper = getWrapperEl()
    if (!wrapper) return
    if (wrapper.dataset && wrapper.dataset.mdsJmHistogramInit === '1') return
    if (wrapper.dataset && wrapper.dataset.mdsJmHistogramBooting === '1') return
    if (wrapper.dataset) wrapper.dataset.mdsJmHistogramBooting = '1'

    const widgetRoot = findWidgetRoot(wrapper)
    if (widgetRoot) {
      if (wrapper.dataset) wrapper.dataset.mdsJmHistogramInit = '1'
      initHistogram(wrapper, widgetRoot)
      return
    }

    // Widget may mount after DOMContentLoaded; observe briefly and retry.
    if (!window.MutationObserver) return
    if (wrapper.dataset && wrapper.dataset.mdsJmHistogramWaiting === '1') return
    if (wrapper.dataset) wrapper.dataset.mdsJmHistogramWaiting = '1'

    const mo = new MutationObserver(function () {
      if (wrapper.dataset && wrapper.dataset.mdsJmHistogramInit === '1') return
      const root = findWidgetRoot(wrapper)
      if (!root) return
      if (wrapper.dataset) wrapper.dataset.mdsJmHistogramInit = '1'
      mo.disconnect()
      initHistogram(wrapper, root)
    })
    mo.observe(wrapper, { childList: true, subtree: true })
  }

  document.addEventListener('DOMContentLoaded', boot)
  window.addEventListener('load', boot, { passive: true })
})();

// Rich text: horizontal cards (text + image)
(function () {
  const ROOT_SELECTORS = [
    '.article-main .article-content.rte',
    '.page-content .description.rte',
    '.product-info-section__content.rte',
    '.product-info-section__content.description-content.rte'
  ]
  const CARD_CLASS = 'list-box-horizontal-card'
  const CARD_TEXT_CLASS = 'list-box-horizontal-left'
  const CARD_MEDIA_CLASS = 'list-box-horizontal-right'
  const SKIP_CARD_CLASS = 'list-box-horizontal-skip'
  const STANDALONE_IMAGE_CLASS = 'article-standalone-image'
  const STANDALONE_IMAGE_WRAP_CLASS = 'article-standalone-image-wrap'
  const LEGACY_CARD_CLASS = 'article-h-card'
  const LEGACY_ROW_CLASS = 'article-inline-image-row'
  const CANVA_SELECTOR = 'span[data-canva-clipboard]'
  const EXCLUDED_CARD_H2_TITLES = new Set([
    'panneaux a couches minces (thin film)',
    'les panneaux solaires souples',
    'les panneaux a demi-cellules (half-cut)'
  ])

  function isRejoignezNousPageRte (el) {
    return !!(el instanceof HTMLElement && el.closest('.page-content--rejoinez-nous'))
  }

  function normalizeText (value) {
    return String(value || '').replace(/\u00a0/g, ' ').trim()
  }

  function normalizeHeadingKey (value) {
    return normalizeText(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
  }

  function isHeading (el) {
    return !!(el instanceof HTMLElement && /^H[1-6]$/.test(el.tagName))
  }

  function sliceNodesFromLastHeading (nodes) {
    if (!Array.isArray(nodes) || !nodes.length) return []
    let lastHeadingIndex = -1
    nodes.forEach(function (node, index) {
      if (isHeading(node)) lastHeadingIndex = index
    })
    return lastHeadingIndex >= 0 ? nodes.slice(lastHeadingIndex) : nodes
  }

  function shouldExcludeHeadingFromCard (node) {
    if (!(node instanceof HTMLElement)) return false
    if (node.tagName !== 'H2') return false
    return EXCLUDED_CARD_H2_TITLES.has(normalizeHeadingKey(node.textContent || ''))
  }

  function stripExcludedHeadingFromStart (nodes) {
    if (!Array.isArray(nodes) || !nodes.length) return []
    if (shouldExcludeHeadingFromCard(nodes[0])) return nodes.slice(1)
    return nodes
  }

  function splitLeadingH2 (nodes) {
    if (!Array.isArray(nodes) || !nodes.length) {
      return []
    }
    const first = nodes[0]
    if (first instanceof HTMLElement && first.tagName === 'H2') {
      return nodes.slice(1)
    }
    return nodes
  }

  function paragraphTextWithoutMedia (p) {
    if (!(p instanceof HTMLElement) || p.tagName !== 'P') return ''
    const clone = p.cloneNode(true)
    clone.querySelectorAll('img,br').forEach(function (node) { node.remove() })
    return normalizeText(clone.textContent)
  }

  function nodeTextWithoutMedia (el) {
    if (!(el instanceof HTMLElement)) return ''
    const clone = el.cloneNode(true)
    clone.querySelectorAll('img,br,' + CANVA_SELECTOR).forEach(function (node) { node.remove() })
    return normalizeText(clone.textContent)
  }

  function removeCanvaArtifacts (root) {
    if (!root || !root.querySelectorAll) return
    root.querySelectorAll(CANVA_SELECTOR).forEach(function (el) { el.remove() })
  }

  function isTextDiv (el) {
    if (!(el instanceof HTMLElement) || el.tagName !== 'DIV') return false
    if (el.querySelector('img,video,iframe,table,figure')) return false
    return nodeTextWithoutMedia(el) !== ''
  }

  function isImageOnlyBlock (el) {
    if (!(el instanceof HTMLElement)) return false

    if (el.tagName === 'IMG') {
      const parent = el.parentElement
      if (parent && parent.querySelectorAll('img').length === 1 && ['P', 'DIV', 'FIGURE', 'A'].includes(parent.tagName)) {
        return false
      }
      return true
    }

    if (!['P', 'DIV', 'FIGURE', 'A'].includes(el.tagName)) return false
    if (el.querySelectorAll('img').length !== 1) return false
    if (nodeTextWithoutMedia(el) !== '') return false
    return !el.querySelector('video,iframe,table,ul,ol,blockquote,h1,h2,h3,h4,h5,h6')
  }

  function isSpacerNode (el) {
    if (!(el instanceof HTMLElement)) return false
    if (!['P', 'DIV'].includes(el.tagName)) return false
    if (isImageOnlyBlock(el)) return false
    if (normalizeText(el.textContent) !== '') return false
    return !el.querySelector('img,video,iframe,table,ul,ol,blockquote,h1,h2,h3,h4,h5,h6')
  }

  function isTextParagraph (el) {
    if (!(el instanceof HTMLElement) || el.tagName !== 'P') return false
    if (isImageOnlyBlock(el)) return false
    return paragraphTextWithoutMedia(el) !== ''
  }

  function isCardTextNode (el) {
    if (!(el instanceof HTMLElement)) return false
    if (isTextParagraph(el) || isHeading(el)) return true
    if (el.tagName === 'UL' || el.tagName === 'OL') return true
    return isTextDiv(el)
  }

  function isManagedCardNode (el) {
    if (!(el instanceof HTMLElement)) return false
    return el.classList.contains(CARD_CLASS) ||
      el.classList.contains(LEGACY_CARD_CLASS) ||
      el.classList.contains(CARD_TEXT_CLASS) ||
      el.classList.contains(CARD_MEDIA_CLASS)
  }

  function isArticleRteContainer (el) {
    if (!(el instanceof HTMLElement)) return false
    if (!document.body || !document.body.classList.contains('page-type-article')) return false
    return !!el.closest('.article-main .article-content.rte')
  }

  function countConsecutiveLeadingSpacersBefore (node) {
    let count = 0
    let prev = node ? node.previousElementSibling : null
    while (isSpacerNode(prev)) {
      count += 1
      prev = prev.previousElementSibling
    }
    return count
  }

  function shouldSkipCardForLeadingSpacers (container, imageNode) {
    if (!isArticleRteContainer(container)) return false
    return countConsecutiveLeadingSpacersBefore(imageNode) >= 2
  }

  function shouldAttachNextText (lastTextNode, nextParagraph) {
    if (!(isTextParagraph(nextParagraph) || isTextDiv(nextParagraph))) return false
    if (!lastTextNode) return true

    const previousText = nodeTextWithoutMedia(lastTextNode)
    const nextText = nodeTextWithoutMedia(nextParagraph)
    const previousLooksComplete = /[.!?:;]\s*$/.test(previousText)
    const nextStartsLowercase = /^[a-z]/.test(nextText)

    return !previousLooksComplete || nextStartsLowercase
  }

  function unwrapLegacyRows (rte) {
    rte.querySelectorAll('.' + LEGACY_ROW_CLASS).forEach(function (row) {
      if (!(row instanceof HTMLElement)) return
      while (row.firstChild) {
        row.parentNode.insertBefore(row.firstChild, row)
      }
      row.remove()
    })
  }

  function splitMixedParagraph (p) {
    if (!(p instanceof HTMLElement)) return null
    if (!['P', 'DIV'].includes(p.tagName)) return null
    if (p.closest('.' + CARD_CLASS + ', .' + LEGACY_CARD_CLASS)) return null

    const images = p.querySelectorAll('img')
    if (images.length !== 1) return null

    const plainText = nodeTextWithoutMedia(p)
    if (plainText === '') return null

    const image = images[0]
    const parentLink = image.parentElement
    const imageNode = (
      parentLink &&
      parentLink.tagName === 'A' &&
      parentLink.querySelectorAll('img').length === 1 &&
      normalizeText(parentLink.textContent) === ''
    )
      ? parentLink
      : image

    const imageParagraph = document.createElement(p.tagName === 'P' ? 'p' : 'div')
    imageParagraph.appendChild(imageNode.cloneNode(true))
    p.insertAdjacentElement('afterend', imageParagraph)
    imageNode.remove()
    return imageParagraph
  }

  function normalizeMixedParagraphs (root) {
    root.querySelectorAll('p, div').forEach(function (node) {
      splitMixedParagraph(node)
    })
  }

  function buildCardAroundImageParagraph (container, imageBlock) {
    if (!(imageBlock instanceof HTMLElement) || imageBlock.parentElement !== container) return
    if (imageBlock.closest('.' + CARD_CLASS + ', .' + LEGACY_CARD_CLASS)) return
    if (shouldSkipCardForLeadingSpacers(container, imageBlock)) {
      imageBlock.classList.add(SKIP_CARD_CLASS)
      return
    }

    const beforeSpacers = []
    const textNodes = []
    let prev = imageBlock.previousElementSibling

    // Collect all consecutive text nodes before the image.
    while (prev && (isCardTextNode(prev) || isSpacerNode(prev))) {
      if (isSpacerNode(prev)) {
        beforeSpacers.unshift(prev)
      } else {
        textNodes.unshift(prev)
      }
      prev = prev.previousElementSibling
    }

    const selectedTextNodes = stripExcludedHeadingFromStart(sliceNodesFromLastHeading(textNodes))
    const contentTextNodes = splitLeadingH2(selectedTextNodes)

    const afterSpacers = []
    let next = imageBlock.nextElementSibling
    while (isSpacerNode(next)) {
      afterSpacers.push(next)
      next = next.nextElementSibling
    }

    let lastTextNode = contentTextNodes.length ? contentTextNodes[contentTextNodes.length - 1] : null
    while (shouldAttachNextText(lastTextNode, next)) {
      contentTextNodes.push(next)
      lastTextNode = next
      next = next.nextElementSibling
      while (isSpacerNode(next)) {
        afterSpacers.push(next)
        next = next.nextElementSibling
      }
    }

    if (!contentTextNodes.length) return

    const card = document.createElement('div')
    card.className = CARD_CLASS

    const textWrap = document.createElement('div')
    textWrap.className = CARD_TEXT_CLASS

    const mediaWrap = document.createElement('div')
    mediaWrap.className = CARD_MEDIA_CLASS

    container.insertBefore(card, contentTextNodes[0])
    card.appendChild(textWrap)
    card.appendChild(mediaWrap)

    contentTextNodes.forEach(function (node) {
      if (node && node.parentElement === container) textWrap.appendChild(node)
    })

    const firstTextNode = contentTextNodes[0]
    beforeSpacers.forEach(function (spacer) {
      if (!(spacer && spacer.parentElement === container)) return
      if (firstTextNode.compareDocumentPosition(spacer) & Node.DOCUMENT_POSITION_FOLLOWING) {
        spacer.remove()
      }
    })

    afterSpacers.forEach(function (spacer) {
      if (spacer && spacer.parentElement === container) spacer.remove()
    })

    if (imageBlock.parentElement === container) {
      mediaWrap.appendChild(imageBlock)
    }
  }

  function buildCardFromDirectChildren (container) {
    if (!(container instanceof HTMLElement)) return
    if (isManagedCardNode(container)) return

    const children = Array.from(container.children).filter(function (node) {
      return node instanceof HTMLElement && !isManagedCardNode(node)
    })
    if (children.length < 2) return

    let imageIndex = -1
    for (let i = children.length - 1; i >= 0; i--) {
      if (isImageOnlyBlock(children[i])) {
        imageIndex = i
        break
      }
    }
    if (imageIndex <= 0) return

    const imageNode = children[imageIndex]
    if (shouldSkipCardForLeadingSpacers(container, imageNode)) {
      imageNode.classList.add(SKIP_CARD_CLASS)
      return
    }

    const before = children.slice(0, imageIndex)
    const selectedBefore = stripExcludedHeadingFromStart(sliceNodesFromLastHeading(before))
    const contentBefore = splitLeadingH2(selectedBefore)
    const beforeHasText = contentBefore.some(isCardTextNode)
    if (!beforeHasText) return

    const beforeAllowed = contentBefore.every(function (node) {
      return isCardTextNode(node) || isSpacerNode(node)
    })
    if (!beforeAllowed) return

    const card = document.createElement('div')
    card.className = CARD_CLASS

    const textWrap = document.createElement('div')
    textWrap.className = CARD_TEXT_CLASS

    const mediaWrap = document.createElement('div')
    mediaWrap.className = CARD_MEDIA_CLASS

    container.insertBefore(card, contentBefore[0])
    card.appendChild(textWrap)
    card.appendChild(mediaWrap)

    contentBefore.forEach(function (node) {
      if (!node.parentElement || node.parentElement !== container) return
      if (isSpacerNode(node)) {
        node.remove()
      } else {
        textWrap.appendChild(node)
      }
    })

    if (imageNode.parentElement === container) {
      mediaWrap.appendChild(imageNode)
    }
  }

  function markStandaloneArticleImages (root) {
    if (!(root instanceof HTMLElement)) return
    if (!document.body || !document.body.classList.contains('page-type-article')) return

    root.querySelectorAll('.' + STANDALONE_IMAGE_WRAP_CLASS).forEach(function (el) {
      el.classList.remove(STANDALONE_IMAGE_WRAP_CLASS)
    })

    root.querySelectorAll('img').forEach(function (img) {
      if (!(img instanceof HTMLImageElement)) return
      img.classList.remove(STANDALONE_IMAGE_CLASS)

      if (img.closest('.' + CARD_CLASS + ', .' + LEGACY_CARD_CLASS)) return
      if (img.closest('.img-wrapper')) return

      img.classList.add(STANDALONE_IMAGE_CLASS)

      const linkParent = img.parentElement && img.parentElement.tagName === 'A'
        ? img.parentElement
        : null
      const wrap = (linkParent ? linkParent.parentElement : img.parentElement) || null
      if (wrap instanceof HTMLElement && !wrap.closest('.' + CARD_CLASS + ', .' + LEGACY_CARD_CLASS)) {
        wrap.classList.add(STANDALONE_IMAGE_WRAP_CLASS)
      }
    })
  }

  function buildCardsInRoot (root) {
    if (isRejoignezNousPageRte(root)) return

    removeCanvaArtifacts(root)
    unwrapLegacyRows(root)
    normalizeMixedParagraphs(root)

    // First pass: handle wrappers with direct child blocks (common in rich-text/metafield markup).
    const containers = [root].concat(Array.from(root.querySelectorAll('div, section, article, li, td, blockquote')))
    containers.forEach(buildCardFromDirectChildren)

    // Second pass: fallback around isolated image-only nodes.
    const imageParagraphs = Array.from(root.querySelectorAll('p, div, figure, a, img')).filter(isImageOnlyBlock)
    imageParagraphs.forEach(function (imageParagraph) {
      const container = imageParagraph.parentElement
      if (container) buildCardAroundImageParagraph(container, imageParagraph)
    })

    markStandaloneArticleImages(root)
  }

  // Disabled: keep the featured image in the hero area at the top of article pages.
  // Previously this moved the hero image into the first rich-text card for text-only posts,
  // which caused inconsistent layouts across articles.
  function buildCardFromFeaturedImage (rte) {
    return
  }

  function run (root) {
    const scope = root && root.querySelectorAll ? root : document
    removeCanvaArtifacts(scope)
    ROOT_SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (rte) {
        buildCardsInRoot(rte)
        buildCardFromFeaturedImage(rte)
      })
    })
  }

  run(document)
  document.addEventListener('DOMContentLoaded', function () { run(document) })
  window.addEventListener('load', function () { run(document) }, { passive: true })
  document.addEventListener('shopify:section:load', function (e) {
    run(e && e.target ? e.target : document)
  })
})();

// Remove Canva clipboard artifacts accidentally pasted from Canva
(function () {
  const SELECTOR = 'span[data-canva-clipboard]'

  function clean (root) {
    const scope = root && root.querySelectorAll ? root : document
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      el.remove()
    })
  }

  clean(document)
  document.addEventListener('DOMContentLoaded', function () { clean(document) })
  window.addEventListener('load', function () { clean(document) }, { passive: true })
  document.addEventListener('shopify:section:load', function (e) {
    clean(e && e.target ? e.target : document)
  })

  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue
          if (node.matches(SELECTOR)) {
            node.remove()
            continue
          }
          clean(node)
        }
      }
    })
    observer.observe(document.documentElement, { childList: true, subtree: true })
  }
})();
